// export const appID = "f363f9f2ab2340b08695bc000d212804";
// export const appCertificate = "616c082c8d984e68845aa61632569240";
// export const channelName = "123";
// export const uid = Math.floor(Math.random() * 1000);
// export const consultaId = "abc";

export const firebaseConfig = {
  apiKey: "AIzaSyALYkzNUUfIwfWS-WvVnJ4ScnJAA3sDRPQ",
  authDomain: "telemedicinacallme.firebaseapp.com",
  projectId: "telemedicinacallme",
  storageBucket: "telemedicinacallme.appspot.com",
  messagingSenderId: "698990305597",
  appId: "1:698990305597:web:4d92d241230170cd9a2554",
};
